<template>
  <div>
    <HeaderComponent />
    <SidebarComponent />
    <div id="main-content" :class="[footerTypeIs, contentClass]">
      <slot></slot>
    </div>
    <AuthFooterComponent :footerType="footerTypeIs" />
  </div>
</template>
<script>
export default {
  name: "DefaultLayout",
  props: {
    props: String,
  },
  watch: {
    isIdle() {
      if (this.isIdle) {
        localStorage.removeItem("jwtToken");
        this.$cookies.remove("transaction-list-filter");
        this.$cookies.remove("remitter-list-filter");
        this.$cookies.remove("receiver-list-filter");
        this.$cookies.remove("receiver-show-deleted-blacklisted");
        this.$toast.success("Ideal timeout...!!", { position: "top-right" });
        this.$router.push("/page-login");
      }
    },
  },
  components: {
    HeaderComponent: () =>
      import("@/components/admin/layouts/header/HeaderComponent.vue"),
    SidebarComponent: () =>
      import("@/components/admin/layouts/sidebar/SidebarComponent.vue"),
    AuthFooterComponent: () =>
      import("@/components/admin/layouts/footer/AuthFooterComponent.vue"),
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    footerTypeIs() {
      var currentfooterType = "";
      if (this.$route.name == "cdashboard") {
        currentfooterType = "client";
      } else {
        currentfooterType = "admin";
      }
      return currentfooterType;
    },

    contentClass() {
      var currentcontentClass = "";
      if (
        this.$route.name == "blog_list" ||
        this.$route.name == "blog_details"
      ) {
        currentcontentClass = "blog-page";
      } else if (
        this.$route.name == "typography" ||
        this.$route.name == "fdocuments" ||
        this.$route.name == "fimages" ||
        this.$route.name == "fmedia"
      ) {
        currentcontentClass = "file_manager";
      } else if (
        this.$route.name == "pgallery" ||
        this.$route.name == "ptimeline"
      ) {
        currentcontentClass = "profilepage_1";
      }
      return currentcontentClass;
    },
  },
};
</script>
